import { useCallback } from 'react';
import translations from '../data/translations';
import { useLocalStorage } from './useLocalStorage';

export function useTranslation() {
  const [language, setLanguage] = useLocalStorage('colobongo_language', 'fr');

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations['fr']?.[key] || translations['en']?.[key] || key;
  }, [language]);

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  }, [setLanguage]);

  return { t, language, setLanguage, toggleLanguage };
}

export default useTranslation;
